/*
 * NVIDIA Inception copy. Approved wording is "Member of NVIDIA Inception": never "partner", "powered by" or
 * "endorsed by" NVIDIA.
 */
export const INCEPTION_MEMBER_LABEL = 'Member of NVIDIA Inception';
export const INCEPTION_MEMBERSHIP_NOTE =
  "ReTax360 is a member of NVIDIA Inception, NVIDIA's program for startups advancing AI.";
export const INCEPTION_PROGRAM_URL = 'https://www.nvidia.com/en-us/startups/';
export const INCEPTION_BADGE_ALT = 'NVIDIA Inception Program member badge';
